import styled, { keyframes } from 'styled-components';
import { theme } from '../../styles/config/theme';
import media from '../../styles/config/mediaQueries';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  };
`;

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${theme.color.black};
  z-index: 3;
  animation: ${fadeIn} 0.5s ease-in-out forwards;
`;

const StyledIframeWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${media.mobile`
    width: 100%;
  `}
  ${media.desktop`
    width: 70%;
  `}
`;

const StyledCloseBtn = styled.button`
  position: fixed;
  right: 35px;
  top: 35px;
  padding: 10px;
  z-index: 2;
`;

export { StyledContainer, StyledIframeWrap, StyledCloseBtn };
